import { Component, OnInit, ViewEncapsulation, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { formatDate } from '@angular/common';
import { LocalStorage } from 'ngx-store';
import { saveAs } from 'file-saver';

//Service
import { ExportService } from '../../../services/exporter.service';
import { ComplianceService } from './../../../services/compliance.service';

//Model
import { VehicleCheck } from './../../../model/compliance.model';
import { Url } from '../../../model/users.model';
import { ThemeSetting } from '../../../model/users.model';
import { FileExport } from '../../../model/exporter.model';

@Component({
    selector: 'app-vehiclechecks',
    templateUrl: './vehiclechecks.component.html',
    styleUrls: ['./vehiclechecks.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [ ComplianceService ]
  })
  
  export class VehicleChecksComponent implements OnInit {
    @LocalStorage() url!: Url;
    @LocalStorage() themeSettings: ThemeSetting;

    public fileStoragePath = this.url.fileStorage;
    rows1 = [];
    vehicleChecks : VehicleCheck[];
    selected = [];
    loadingIndicator: boolean = true;
    reorderable: boolean = true;
    vehicleChecksCount: number = 0;

    showDate:boolean=true;
    showEtag:boolean=true;
    showRego:boolean=true;
    showType:boolean=true;
    showDriver:boolean=true;
    showStatus:boolean=true;
    showFile:boolean=true;

    //Handles the name, type and content of the to-be exported file
    public exp_excel: FileExport;
    public exp_pdf: FileExport;

    //Stores the filtered and formatted content of the file
    formatted_list : any;

    columns = [
        { prop: 'id' },
        { prop: 'date_done' },
        { prop: 'time_done' },
        { prop: 'manifest_id' },
        { prop: 'phase_id' },
        { prop: 'driver_first_name' },
        { prop: 'driver_last_name' },
        { prop: 'fleet_rego' },
        { prop: 'fleet_type_name' },
        { prop: 'fleet_etag_no' },
        { prop: 'is_compliant' },
        { prop: 'file' },
      ];
    
    constructor(  private http: HttpClient, 
                  private complianceService: ComplianceService,
                  private exporter: ExportService
                  ){
              
    }

    ngOnInit() {
      this.getVehicleChecks();

      //Declaration to handle the name, type and content of the file
      this.exp_excel = {title:'', list_data:'', type:''};
      this.exp_pdf = {title:'', list_data:'', type:''};

    }

    getVehicleChecks(){
      this.complianceService.getVehicleChecks().subscribe(data=>{
        if (data["vehicle_tests"].length > 0)
        this.selected = [data["vehicle_tests"][0]];
        this.rows1 = data["vehicle_tests"];
        this.fullRowsVehicleChecks = data["vehicle_tests"];
        this.vehicleChecksCount = this.rows1.length;
        setTimeout(() => { this.loadingIndicator = false; }, 1500);
        console.log(data);
    })
    }

    private formatDate(inDate: string) {
      let formatedDate: Date;
      formatedDate = new Date(inDate.replace(/-/g, "/"));
      return formatedDate;
    }

    print1(): void {
      let printContents, popupWin;
      printContents = document.getElementById('print-section1').innerHTML;
      popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
      popupWin.document.open();
      popupWin.document.write(`
        <html>
        <head>
        <title>Vehicle Checks List</title>
        <style>
        @page {
          size: A4;
        }

        table {
          border-collapse: collapse;
          border-spacing: 0;
          width: 100%;
          border: 1px solid #ddd !important;
      }

      th, td {
          text-align: left;
          padding: 16px;
      }


      tr:nth-child(even) {
          background-color: #f2f2f2 !important;
          box-shadow: inset 0 0 0 1000px #f2f2f2;
      }

      .fn {
        float: footnote;
      }

      thead {
        box-shadow: inset 0 0 0 1000px #f2f2f2;
      }
              
      </style>
      </head>
      <body onload="window.print();window.close()">${printContents}</body>
        </html>`
      );
      popupWin.document.close();
    }

    showFilters: boolean = false;
    filterVDriver: string = '';
    filterVDate: Date;
    filterVRego: string = '';
    isFilterEmpty: boolean = true;
    tempVehicleChecks = [];
    fullRowsVehicleChecks = [];

    public toggleFilters() {
      if (this.showFilters) this.showFilters = false;
      else this.showFilters = true;
    }

    updateFilter() {
      this.isFilterEmpty = false;

      this.tempVehicleChecks = this.fullRowsVehicleChecks.filter(data => { 
        if (data.date_done && this.filterVDate){
          return (new Date(data.date_done).toString() === new Date(this.filterVDate).toString());
        }else{
          return data.date_done;
        };
      });
      
      this.tempVehicleChecks = this.tempVehicleChecks.filter(data => {
       if (this.filterVDriver && data.driver_first_name){
          return (data.driver_first_name + ' ' + data.driver_last_name).toLowerCase().indexOf(this.filterVDriver.toLowerCase()) !== -1 || !this.filterVDriver.toLowerCase();    
        }else{
          return (data.driver_first_name + ' ' + data.driver_last_name);
        }
      });

      this.tempVehicleChecks = this.tempVehicleChecks.filter(data => {
        if (this.filterVRego && data.fleet_rego){
          return (data.fleet_rego.toLowerCase().indexOf(this.filterVRego.toLowerCase()) !== -1 || !this.filterVRego.toLowerCase());    
        }else{
          return data.fleet_rego;
        }
      });

      
      this.rows1 = this.tempVehicleChecks;
      this.vehicleChecksCount = Object.keys(this.tempVehicleChecks).length;
    }

    public resetFilters() {
      this.filterVDriver = '';
      this.filterVDate = null;
      this.filterVRego = "";
      this.rows1 = this.fullRowsVehicleChecks;
      this.isFilterEmpty = true;
      this.vehicleChecksCount = Object.keys(this.rows1).length;

    }

  /*** Export... Module ***/
  //Replaces an attribute name for reading comprehension
  renameKey( obj, oldKey, newKey ) {
    obj[newKey] = obj[oldKey];
    delete obj[oldKey];
  }

  //Formats readable header names in the given table
  vehicleCheck_generateHeaders(list_vehicleCheck): any{
    const arr = JSON.parse(list_vehicleCheck);
    arr.forEach( obj => {
      this.renameKey( obj, 'date_done', 'Date' );
      this.renameKey( obj, 'fleet_etag_no', 'Etag No' );
      this.renameKey( obj, 'fleet_rego', 'REGO' );
      this.renameKey( obj, 'fleet_type_name', 'Type' );
      this.renameKey( obj, 'driver_first_name', 'Driver' );
      this.renameKey( obj, 'is_compliant', 'Status' );
      this.renameKey( obj, 'file', 'File' );
    });
    const updatedJson = JSON.stringify( arr );
    return updatedJson;
  }

  //Filters every column in the table list
  vehicleCheck_generateColumnsWithFilter(list_vehicleCheck){
      const arr = JSON.parse(JSON.stringify(list_vehicleCheck));
      arr.forEach( obj => {
        //Merge First and Last Names in the list
        obj['driver_first_name'] =  obj['driver_first_name'] + ' ' + obj['driver_last_name'];

        //To display appropriate vehicle check status
        if(obj['is_compliant'] == 1)
          obj['is_compliant'] = 'Compliant';
        else
          obj['is_compliant'] = 'Non-Compliant';

        //Format date
        obj['date_done'] = formatDate(obj['date_done'], 'dd MMM yyyy', 'en_US');

        //remove filtered columns
        if(!this.showDate){
          delete obj['date_done'];
        };
        if(!this.showEtag){
          delete obj['fleet_etag_no'];
        };
        if(!this.showRego){
          delete obj['fleet_rego'];
        }
        else {
          if(obj['fleet_rego'] == null) {
            obj['fleet_rego'] = '';
          }
        };
        if(!this.showType){
          delete obj['fleet_type_name'];
        };
        if(!this.showDriver){
          delete obj['driver_first_name'];
        };
        if(!this.showStatus){ 
          delete obj['is_compliant'];
        };
        if(!this.showFile){
          delete obj['file'];
        };
        delete obj['id'];
        delete obj['fleet_id'];
        delete obj['driver_id'];
        delete obj['driver_last_name'];
        delete obj['time_done'];
        delete obj['manifest_id'];
        delete obj['phase_id'];
        delete obj['odometer'];
        delete obj['created_at'];
        delete obj['updated_at'];
        delete obj['test_status_id'];
      });
      const updatedJson = JSON.stringify( arr );
      return updatedJson;                         
  }

  //Exports  table to CSV file
  vehicleCheck_exportToCSV(){
      if(this.rows1.length >0){
          let with_header_format, with_column_filter;
          
          //generate json with filtered column
          with_column_filter = this.vehicleCheck_generateColumnsWithFilter(this.rows1);

          //generate json with format header
          this.formatted_list = this.vehicleCheck_generateHeaders(with_column_filter);

          //export to file
          let current_date = new Date();
          let csv_file = '[TMS]Compliance_Vehicle_Checks_' + this.formattedDate(current_date);
          this.exporter.exportToCSV(this.formatted_list, csv_file, 'TMS Compliance - Vehicle Checks');
      }
  };

  //Exports table to PDF file
  vehicleCheck_exportToPDF(){
    if(this.rows1.length >0){
      let with_header_format, with_column_filter;

      //generate json with filtered column
      with_column_filter = this.vehicleCheck_generateColumnsWithFilter(this.rows1);

      //generate json with format header
      this.formatted_list = this.vehicleCheck_generateHeaders(with_column_filter);

      //export to file
      let current_date = new Date();

      let pdf_file = '[TMS]Compliance_Vehicle_Checks_' + this.formattedDate(current_date);
      this.exp_pdf.title = 'VEHICLE CHECKS';
      this.exp_pdf.type = 'pdf';
      this.exp_pdf.list_data = this.formatted_list;
      this.exporter.exportToPDF(this.exp_pdf).subscribe(data=>{
        saveAs(data, pdf_file + '.' + this.exp_pdf.type);
      });
    }
  };

  //Exports table to MS Excel file
  vehicleCheck_exportToExcel(){
      if(this.rows1.length >0){
          let with_header_format, with_column_filter;
          
          //generate json with filtered column
          with_column_filter = this.vehicleCheck_generateColumnsWithFilter(this.rows1);

          //generate json with format header
          this.formatted_list = this.vehicleCheck_generateHeaders(with_column_filter);

          //export to file
          let current_date = new Date();
          let excel_file = '[TMS]Compliance_Vehicle_Checks_' + this.formattedDate(current_date);
          this.exp_excel.title = 'VEHICLE CHECKS';
          this.exp_excel.type = 'xlsx';
          this.exp_excel.list_data = this.formatted_list;
          this.exporter.exportToExcel(this.exp_excel).subscribe(data=>{
              console.log(data);
              saveAs(data, excel_file)

          });
      }
  }; 

  //Returns a date format in the file name
  public formattedDate(d = new Date) {
    let month = String(d.getMonth() + 1);
    let day = String(d.getDate());
    const year = String(d.getFullYear());
  
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
  
    return `${day}/${month}/${year}`;
  }
}